<template>
  <div ref="dropdownBox" :id="dropdownId" class="select_box"
    :class="{ open: dropdownBox, required: required ? 'required' : '' }">
    <button type="button" class="btn_select" title="항목선택" @click="dropdownBtn(dropdownId)">
      <span ref="dropdownSelected">
        {{ selectedOptionName }}
      </span>
    </button>

    <div class="select_list">
      <ul>
        <li v-for="(option, index) in items" :key="index" :class="option.className">
          <button type="button" title="선택" @click="selectOption(option)">
            {{ option.name }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropDown',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    dropdownId: {
      type: String,
      default: ''
    },
    optionName: {
      type: String,
      default: '항목 선택'
    },
  },
  data() {
    return {
      dropdownBox: false,
      required: false,
      selectedOptionName: this.optionName // 선택된 항목의 이름을 표시하기 위한 데이터
    };
  },
  watch: {
    optionName(newName) {
      this.selectedOptionName = newName;
    }
  },
  methods: {
    dropdownBtn(selectedId) {
      const dropdownList = document.querySelectorAll('.select_box');
      dropdownList.forEach((ele) => {
        const id = ele.getAttribute('id');
        const isOpen = id === selectedId && !ele.classList.contains('open');
        ele.classList.toggle('open', isOpen);
      });
    },
    selectOption(option) {
      this.selectedOptionName = option.name; // 선택된 항목 이름 표시
      this.$emit('itemSelected', option.value); // 부모 컴포넌트에 선택된 값 전송
      this.$emit('update:modelValue', option.value); // 부모 컴포넌트에 선택된 값 전송
      this.dropdownBtn(this.dropdownId); // 드롭다운 닫기
    },
    optionIntialize(option) {
      this.selectedOptionName = option.name; // 선택된 항목 이름 표시
    },
    dropdownTouch(e) {
      const dropdownBox = this.$refs.dropdownBox;
      if (!e.target.closest('.select_box')) {
        const isOpen = dropdownBox.classList.contains('open');
        if (isOpen) {
          dropdownBox.classList.remove('open');
        }
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.dropdownTouch);
  },
  unmounted() {
    document.removeEventListener("click", this.dropdownTouch);
  }
}
</script>
